import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import Y from '../../../y18n'
import * as userActions from '../../../store/users'
import Styles from '../../../common/styles'

const mapStateToProps = state => ({
  users: state.users
})

const mapDispatchToProps = dispatch => ({
  userActions: bindActionCreators(userActions, dispatch)
})

class SetTemporaryPasswordDialog extends Component {
  state = {
    id: '',
    password: '',
    confirmPassword: '',
    error: null
  }

  closeFormDialog = () => {
    this.props.userActions.resetTempPassword()
  }

  inputChanged = name => event => {
    this.setState({ [name]: event.target.value })
  }

  submitChanges = e => {
    e.preventDefault()
    if (this.state.password !== this.state.confirmPassword) {
      this.setState({ error: 'Password and Confirm password must match!' })
    } else {
      this.props.userActions.submitTempPassword(this.props.users.tempPassword.id, this.state.password)
    }
  }

  render () {
    const { classes, users, userActions } = this.props
    const { password, confirmPassword } = this.state
    if (!users.tempPassword && !users.tempPassword.status) return null
    return (
      <div>
        <Dialog
          open={users.tempPassword.status}
          onClose={() => userActions.resetTempPassword()}
          classes={{
            paper: classes.dialogContent
          }}
        >
          <form onSubmit={e => this.submitChanges(e)}>
            <DialogTitle style={{ paddingBottom: '10px' }}>{Y`Set temporary password for user`}</DialogTitle>
            <Typography
              variant='body2'
              style={{ paddingLeft: '24px', paddingRight: '24px' }}
            >{Y`The user will be prompted to change this password the next time he or she logs in`}</Typography>
            <DialogContent>
              <TextField
                margin='normal'
                label={Y`Password`}
                type='password'
                value={password || ''}
                onChange={this.inputChanged('password')}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
                required
                fullWidth
              />
              <TextField
                margin='normal'
                label={Y`Confirm password`}
                type='password'
                value={confirmPassword || ''}
                onChange={this.inputChanged('confirmPassword')}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
                required
                fullWidth
              />
            </DialogContent>
            <div className={classes.textRow}>
              {this.state.error ? <Typography variant='body2' /> : ''}
            </div>
            <DialogActions>
              <Button onClick={() => userActions.resetTempPassword()}>{Y`Cancel`}</Button>
              <Button type='submit' variant='raised' color='primary' style={{ color: '#fff' }}>
                {Y`Save`}
              </Button>
            </DialogActions>
          </form>
        </Dialog>
      </div>
    )
  }
}

SetTemporaryPasswordDialog = connect(mapStateToProps, mapDispatchToProps)(SetTemporaryPasswordDialog)
export default withStyles(Styles)(SetTemporaryPasswordDialog)



// WEBPACK FOOTER //
// ./src/pages/users/containers/temporary-password-dialog.js